import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./store";
import CONF from "./config";
import Axios from "axios";
import Bus from "./bus";
import analytics from "./helpers/analytics";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter(to, from, next) {
        if (!window.localStorage.getItem("oid")) {
          window.localStorage.setItem("independent", "true");
          analytics.pageview("/").then(() => {
            analytics.event("Independent", "enter", "Car Grid");
            next();
          });
        } else {
          if (window.localStorage.getItem("had_error")) {
            analytics.pageview("/sfmc/").then(() => {
              analytics.event("HadError", "enter", "Car Grid");
              next();
            });
            window.localStorage.removeItem("oid");
          } else {
            analytics.pageview("/sfmc/").then(() => {
              analytics.event("Funnel", "enter", "Car Grid");
              next();
            });
            window.localStorage.removeItem("oid");
          }
        }
      }
    },
    {
      path: "/filled/:car",
      name: "filled",
      component: () =>
        import(/* webpackChunkName: "filled" */ "./views/Filled.vue"),
      beforeEnter(to, from, next) {
        // window.ga("send", "event", "Funnel", "enter", "Revisit");
        analytics.event("Funnel", "enter", "Revisit");
        next();
      }
    },
    {
      path: "/404",
      name: "notfound",
      component: () =>
        import(/* webpackChunkName: "errors" */ "./views/NotFound.vue")
    },
    {
      path: "/:car",
      name: "car",
      component: () => import(/* webpackChunkName: "car" */ "./views/Car.vue"),
      beforeEnter(to, from, next) {
        let url = CONF.apiUrl;
        if (store.state.form.form.orderId !== 0) {
          Axios.get(url + "hasform/" + store.state.form.form.orderId)
            .then(r => {
              if (parseInt(r.data) === 0) {
                store.commit("setHasForm", false);
              } else {
                store.commit("setHasForm", true);
              }
            })
            .then(() => {
              if (store.getters.hasForm) {
                next("/filled");
              } else {
                // window.ga("send", "event", "Funnel", "enter", "Form");
                if (window.localStorage.getItem("oid")) {
                  analytics.event("Funnel", "enter", "Form");
                  analytics.pageview("/sfmc/" + to.params.car);
                } else if (window.localStorage.getItem("independent")) {
                  analytics.event("Independent", "enter", "Form");
                  analytics.pageview("/" + to.params.car);
                } else {
                  analytics.event("Direct", "enter", "Form");
                }
                next();
              }
            })
            .catch(e => {
              analytics.event(
                "Error",
                "on_form",
                window.localStorage.getItem("oid")
              );
              window.localStorage.setItem("had_error", "on_form");
              next("/");
              Bus.$emit("apiError", e);
              window.console.error(e);
            });
        } else {
          if (window.localStorage.getItem("independent")) {
            analytics.event("Independent", "enter", "Form");
            analytics.pageview("/" + to.params.car);
          } else if (window.localStorage.getItem("oid")) {
            analytics.event("Funnel", "enter", "Form");
            analytics.pageview("/sfmc/" + to.params.car);
          } else {
            analytics.event("Direct", "enter", "Form");
          }
          next();
        }
      }
    },
    {
      path: "/:car/yhteenveto",
      name: "summary",
      component: () =>
        import(/*webpackChunkName: "summary" */ "./views/Summary.vue"),
      beforeEnter(to, from, next) {
        let url = CONF.apiUrl;
        if (store.state.form.form.orderId !== 0) {
          Axios.get(url + "hasform/" + store.state.form.form.orderId)
            .then(r => {
              if (parseInt(r.data) === 0) {
                store.commit("setHasForm", false);
              } else {
                store.commit("setHasForm", true);
              }
            })
            .then(() => {
              if (!store.getters.hasForm) {
                // window.ga("send", "event", "Funnel", "enter", "Summary");
                if (window.localStorage.getItem("oid")) {
                  analytics.event("Funnel", "enter", "Summary");
                  analytics.pageview("/sfmc/" + to.params.car + "/yhteenveto");
                }
                next();
              } else {
                next("/filled");
              }
            })
            .catch(e => {
              analytics.event(
                "Error",
                "on_summary",
                window.localStorage.getItem("oid")
              );
              window.localStorage.setItem("had_error", "on_summary");
              Bus.$emit("apiError", e);
              next("/");
              window.console.error(e);
            });
        } else {
          if (window.localStorage.getItem("independent")) {
            analytics.event("Independent", "enter", "Summary");
            analytics.pageview("/" + to.params.car + "/yhteenveto");
          } else if (window.localStorage.getItem("oid")) {
            analytics.event("Funnel", "enter", "Summary");
            analytics.pageview("/sfmc/" + to.params.car + "/yhteenveto");
          } else {
            analytics.event("Direct", "enter", "Summary");
          }
          next();
        }
      }
    },
    {
      path: "/order/:orderId",
      name: "order",
      beforeEnter(to, from, next) {
        store.commit("clearChoises");
        store.commit("clearCarImage");
        store.commit("clearForm");
        let url = CONF.apiUrl;
        let key;
        window.localStorage.setItem("oid", to.params.orderId);
        Axios.get(url + "hasform/" + to.params.orderId)
          .then(r => {
            window.console.log(r);
            if (typeof r.data === Object) {
              if ("fail" in r.data) {
                analytics.event(
                  "Error",
                  "on_hasform",
                  window.localStorage.getItem("oid")
                );
                window.localStorage.setItem("had_error", "on_hasform");
                next("/");
              }
            }
            if (parseInt(r.data) === 0) {
              store.commit("setHasForm", false);
            } else {
              store.commit("setHasForm", true);
              store.dispatch("setChoises", {
                choises: JSON.parse(r.data.form.choises),
                defaults: JSON.parse(r.data.form.defaults)
              });
            }
          })
          .catch(e => {
            analytics.event(
              "Error",
              "on_fail_hasform",
              window.localStorage.getItem("oid")
            );
            window.localStorage.setItem("had_error", "on_fail_hasform");
            next("/");
            Bus.$emit("apiError", e);
            window.console.error(e);
          });
        Axios.get(url + "order/" + to.params.orderId)
          .then(r => {
            let form = r.data.form;
            key = r.data.key;
            store.commit("setFirstName", form.first_name);
            store.commit("setLastName", form.last_name);
            store.commit("setEmail", form.email);
            store.commit("setDealer", form.dealer);
            store.commit("setOrderId", r.data.order);
          })
          .then(() => {
            if (store.getters.hasForm) {
              next("/filled/" + key);
            } else {
              // window.ga("send", "event", "Funnel", "enter", "WithOrder");
              analytics.event("Funnel", "enter", "WithOrder");
              next("/" + key.toLowerCase());
            }
          })
          .catch(e => {
            analytics.event(
              "Error",
              "on_order",
              window.localStorage.getItem("oid")
            );
            window.localStorage.setItem("had_error", "on_order");
            next("/");
            Bus.$emit("apiError", e);
            window.console.error(e);
          });
      }
    },
    {
      path: "/:car/kiitos",
      name: "thankyou",
      component: () =>
        import(/* webpackChunkName: "thankyou" */ "./views/ThankYou.vue"),
      beforeEnter(to, from, next) {
        // window.ga("send", "event", "Funnel", "enter", "ThankYou");
        if (window.localStorage.getItem("oid")) {
          analytics.event("Funnel", "enter", "ThankYou");
          analytics.pageview("/sfmc/" + to.params.car + "/kiitos");
        } else if (window.localStorage.getItem("independent")) {
          analytics.event("Independent", "enter", "ThankYou");
          analytics.pageview("/" + to.params.car + "/kiitos");
        } else {
          analytics.event("Direct", "enter", "ThankYou");
        }
        next();
      }
    },
    {
      path: "/:car/palaute",
      name: "feedback",
      component: () =>
        import(/* webpackChunkName: "feedback" */ "./views/Feedback.vue")
    }
  ]
});
